<template>
  <div class="tag-cloud">
    <ItemTag
      v-if="product.crude_extract_sub_type && showCrudeExtractTypeFieldCheck(product.category)"
      :name="product.crude_extract_sub_type.name"
      :tooltip="'Crude Extract Type'"
    />
    <ItemTag
      v-if="product.distillate_extract_sub_type && showDistillateExtractTypeFieldCheck(product.category)"
      :name="product.distillate_extract_sub_type.name"
      :tooltip="'Distillate Extract Type'"
    />
    <ItemTag
      v-if="product.state_of_material && showStateOfMaterialsFieldCheck(product.category)"
      :name="product.state_of_material.name"
      :tooltip="'State Of Materials'"
    />
    <ItemTag
      v-if="product.grow_environment && showGrowEnvironmentFieldCheck(product.category)"
      :name="product.grow_environment.name"
      :tooltip="'Grow Environment'"
    />
    <ItemTag v-if="product.grow_medium && showGrowMediumFieldCheck(product.category)" :name="product.grow_medium.name" :tooltip="'Grow Medium'" />
    <ItemTag
      v-if="product.drying_method && showDryingMethodsFieldCheck(product.category)"
      :name="product.drying_method.name"
      :tooltip="'Drying Method'"
    />
    <ItemTag
      v-if="product.storage_type && showStorageTypesFieldCheck(product.category)"
      :name="product.storage_type.name"
      :tooltip="'Storage Type'"
    />
    <ItemTag
      v-if="product.container_type && showContainerTypesFieldCheck(product.category)"
      :name="product.container_type.name"
      :tooltip="'Container Type'"
    />
    <ItemTag
      v-if="product.trim_method && showTrimmingMethodsFieldCheck(product.category)"
      :name="product.trim_method.name"
      :tooltip="'Trim Method'"
    />
    <ItemTag
      v-if="product.flowering_period && showFloweringPeriodsFieldCheck(product.category)"
      :name="product.flowering_period.name"
      :tooltip="'Flowering Period'"
    />
    <ItemTag
      v-if="product.feminized_type && showFeminizedCheck(product.category)"
      :name="product.feminized_type.name"
      :tooltip="'Feminization Technique'"
    />
    <ItemTag v-if="product.lineage && showLineageCheck(product.category)" :name="product.lineage + ' ' + 'Lineage'" :tooltip="'Lineage'" />
    <ItemTag v-if="product.feminized && showFeminizedCheck(product.category)" :name="'Feminized'" :tooltip="'Feminized'" />
    <ItemTag
      v-if="product.germination_rate && showGerminationRateCheck(product.category)"
      :name="product.germination_rate + '% ' + 'Germination Rate'"
      :tooltip="'Germination Rate'"
    />
    <ItemTag
      v-if="product.herm_male_rate && showHermMaleRateCheck(product.category)"
      :name="product.herm_male_rate + '% ' + 'Feminization Rate'"
      :tooltip="'Feminization Rate'"
    />
    <ItemTag
      v-if="product.yields_per_acre_outdoor && showYieldsPerAcreOutdoorCheck(product.category)"
      :name="product.yields_per_acre_outdoor + ' ' + 'Per Acre'"
      :tooltip="'Yields Per Acre (Outdoor)'"
    />
    <ItemTag
      v-if="product.per_sq_ft_indoor && showPerSqFtIndoorCheck(product.category)"
      :name="product.per_sq_ft_indoor + ' ' + 'Per Square Foot'"
      :tooltip="'Per Sq Ft (Indoor)'"
    />
    <ItemTag v-if="product.curing_method && showCuringMethodCheck(product.category)" :name="product.curing_method" :tooltip="'Curing Method'" />
    <ItemTag
      v-if="product.extraction_method && showExtractionMethodsFieldCheck(product.category)"
      :name="product.extraction_method.name"
      :tooltip="'Extraction Method'"
    />
    <ItemTag v-if="product.flavor && showProductFlavorsCheck(product.category)" :name="product.flavor.name" :tooltip="'Product Flavor'" />
    <ItemTag
      v-if="product.infusion_method && showInfusionMethodFieldCheck(product.category)"
      :name="product.infusion_method.name"
      :tooltip="'Carrier Oil'"
    />
    <ItemTag v-if="product.for_pets && showForPetsFieldCheck(product.category)" :name="'For Pets'" :tooltip="'For Pets'" />
    <span v-if="product.environmental_issues && product.environmental_issues.length > 0">
      <span v-for="issue in product.environmental_issues" :key="issue.id">
        <ItemTag :name="issue.name" :tooltip="'Environmental Issue'" />
      </span>
    </span>
  </div>
</template>
<script>
import ItemTag from "@/components/common/ItemTag.vue";
import {
  showCultivarFieldCheck,
  showCultivarTypeFieldCheck,
  showGrowEnvironmentFieldCheck,
  showGrowMediumFieldCheck,
  showTrimmingMethodsFieldCheck,
  showDryingMethodsFieldCheck,
  showStorageTypesFieldCheck,
  showContainerTypesFieldCheck,
  showUnitOfMeasurementFieldCheck,
  showUnitSizeUnitOfMeasurementFieldCheck,
  showIngredientsFieldCheck,
  showPackToOrderPricesCheck,
  showPackagedUnitSizeFieldCheck,
  showGramPerPrerollCheck,
  showGovernmentAgenciesCheck,
  showFeminizedCheck,
  showFloweringPeriodsCheck,
  showYieldsPerAcreOutdoorCheck,
  showPerSqFtIndoorCheck,
  showCuringMethodCheck,
  showGerminationRateCheck,
  showLineageCheck,
  showEnvironmentalIssuesFieldCheck,
  showTypesFieldCheck,
  showExtractionMethodsFieldCheck,
  showProductFlavorsCheck,
  showProductAdditivesCheck,
  showUnitsSizeCheck,
  showPackageAndCaseOptions,
  showInfusionMethodFieldCheck,
  showForPetsFieldCheck,
  showPrerollTypeFieldCheck,
  showPrePopulateFieldCheck,
  isCommonCategoryFieldCheck,
  showHermMaleRateCheck,
  showStateOfMaterialsFieldCheck,
  showCrudeExtractTypeFieldCheck,
  showDistillateExtractTypeFieldCheck,
} from "@/services/inventory/showProductFieldChecks";

export default {
  components: {
    ItemTag,
  },
  props: {
    product: { type: Object, required: true },
  },
  data() {
    return {
      industry: APP_INDUSTRY,
    };
  },
  mounted() {
    console.log(this.product);
  },
  computed: {},
  methods: {
    showCultivarFieldCheck,
    showCultivarTypeFieldCheck,
    showGrowEnvironmentFieldCheck,
    showGrowMediumFieldCheck,
    showTrimmingMethodsFieldCheck,
    showDryingMethodsFieldCheck,
    showStorageTypesFieldCheck,
    showContainerTypesFieldCheck,
    showUnitOfMeasurementFieldCheck,
    showUnitSizeUnitOfMeasurementFieldCheck,
    showIngredientsFieldCheck,
    showPackToOrderPricesCheck,
    showPackagedUnitSizeFieldCheck,
    showGramPerPrerollCheck,
    showGovernmentAgenciesCheck,
    showFeminizedCheck,
    showFloweringPeriodsCheck,
    showYieldsPerAcreOutdoorCheck,
    showPerSqFtIndoorCheck,
    showCuringMethodCheck,
    showGerminationRateCheck,
    showLineageCheck,
    showEnvironmentalIssuesFieldCheck,
    showTypesFieldCheck,
    showExtractionMethodsFieldCheck,
    showProductFlavorsCheck,
    showProductAdditivesCheck,
    showUnitsSizeCheck,
    showPackageAndCaseOptions,
    showInfusionMethodFieldCheck,
    showForPetsFieldCheck,
    showPrerollTypeFieldCheck,
    showPrePopulateFieldCheck,
    isCommonCategoryFieldCheck,
    showHermMaleRateCheck,
    showStateOfMaterialsFieldCheck,
    showCrudeExtractTypeFieldCheck,
    showDistillateExtractTypeFieldCheck,
  },
};
</script>
